import React, {useState} from "react"
import {useModal, useSolutionRepository, useLocal, useRoomParameters, useRoomSetup, useSolution, useProgress, useMessage, useHelpCta} from "../../AppContext"
import {apiDataToRoomSetup} from "../../Hooks/RoomSetup"
import {dispatchSolutionLoadedEvent} from "../../Hooks/SolutionRepository"
import {InputTextCenter} from "../../Components/Input"
import {Button} from "../../Components/Button"
import {iconLoad} from "../../Helper/Icons"
import style from "./LodeByCode.css"

export const LodeByCode = () => {
    const helpCta = useHelpCta()
    const message = useMessage()
    const modal = useModal()
    const progress = useProgress()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const solutionRepository = useSolutionRepository()
    const solution = useSolution()
    const local = useLocal()
    const [state, setState] = useState("")
    const isDisabled = !state.trim().length

    const onChange = (event) => {
        setState(event.target.value)
    }

    const onLoad = async () => {
        const load = async () => {
            try {
                const loadedRoom = await solutionRepository.load(state)
                roomSetup.setRoom(apiDataToRoomSetup(loadedRoom.plannings[0].room, roomParameters.getRoomParameters().interiors))
                solution.setPlannings(loadedRoom.plannings[0].room.id, loadedRoom.plannings)
                await solution.save() // Call added to write roomcode to session storage. Writing sessions storage should not be part of this call. See reasoning in #25320-21.
                modal.close()
                helpCta.disable()

                setTimeout(() => {
                    progress.gotoSolution()
                    dispatchSolutionLoadedEvent()
                }, 100)
            } catch (error) {
                message.showError(local.__(error.message))
            }
        }
        message.showPrompt(local.__("Möchten Sie den aktuellen Raum verwerfen und den Raum %roomCode% laden?", {roomCode: state}), load)
    }

    return <div className={style.load}>
        <div className={style.label}>{local.__("geteilten Raum laden")}</div>
        <div className={style.form}>
            <div className={style.cta}>{local.__("Laden Sie einen Raumplan über ein geteilten 12 stelligen Raumcode.")}</div>
            <div>
                <InputTextCenter value={state} onChange={onChange} placeholder={local.__("Raumcode")}/>
                <Button isDisabled={isDisabled} onClick={onLoad}>{iconLoad}{local.__("Raum laden")}</Button>
            </div>
        </div>
    </div>
}

